export const NETWORK_ACTIVITY = "NETWORK_ACTIVITY";
export const SET_ME = "SET_ME";
export const UPSERT_PROFILE = "UPSERT_PROFILE";
export const UPSERT_WORLDS = "UPSERT_WORLDS";
